import { render, staticRenderFns } from "./StudentsPendingInviteTableColumn.vue?vue&type=template&id=82e9cb7a&scoped=true&"
import script from "./StudentsPendingInviteTableColumn.vue?vue&type=script&lang=js&"
export * from "./StudentsPendingInviteTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./StudentsPendingInviteTableColumn.vue?vue&type=style&index=0&id=82e9cb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e9cb7a",
  null
  
)

export default component.exports